import { render, staticRenderFns } from "./OrderInProgressTodoView.vue?vue&type=template&id=47ef017b"
import script from "./OrderInProgressTodoView.vue?vue&type=script&lang=js"
export * from "./OrderInProgressTodoView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports